import {
  email,
  required,
  useGetIdentity,
  useGetList,
  useRecordContext,
} from "ra-core";
import { BooleanInput } from "@/components/admin/boolean-input";
import { SelectInput } from "@/components/admin/select-input";
import { TextInput } from "@/components/admin/text-input";

import type { Role, Sale } from "../types";

export function SalesInputs() {
  const { identity } = useGetIdentity();
  const record = useRecordContext<Sale>();
  const { data: allRoles, isPending: isPendingRoles } = useGetList<Role>(
    "roles",
    {
      pagination: { page: 1, perPage: 100 },
      sort: { field: "id", order: "ASC" },
    },
  );
  // Only an admin may grant the admin role, only a developer the developer
  // role (enforced server-side too)
  const roles = allRoles?.filter(
    (role) =>
      role.id === record?.role_id ||
      identity?.roleKey === "developer" ||
      (role.key !== "developer" &&
        (role.key !== "admin" || identity?.roleKey === "admin")),
  );
  const self = record?.id != null && record?.id === identity?.id;
  return (
    <div className="space-y-4 w-full">
      <TextInput source="first_name" validate={required()} helperText={false} />
      <TextInput source="last_name" validate={required()} helperText={false} />
      <TextInput
        source="email"
        validate={[required(), email()]}
        helperText={false}
      />
      <SelectInput
        source="role_id"
        choices={roles}
        optionText="name"
        isPending={isPendingRoles}
        validate={required()}
        readOnly={self}
        disabled={self}
        helperText={self ? "crm.team.own_role" : false}
      />
      <BooleanInput
        source="disabled"
        readOnly={self}
        disabled={self}
        helperText={false}
      />
    </div>
  );
}
